// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-y-label {
  padding: 0;
  line-height: 0;
  color: #69686d;
  font-size: 12px;
}

.card-body {
  padding: 0;
}

#graphTitle {
  font-size: 25px;
}

.card {
  padding: 20px;
}

.icon-open {
  width: 14px;
  height: 14px;
  border-radius: 8px;
  display: inline-block;
}

th,
td {
  font-size: 12px;
  padding: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
